import { LevelType } from 'data/types';
import { isLevelConditioned } from 'utils/structure';

export function isAddSpacesLevelStepAutoSkippable(level: LevelType): boolean {
  return (
    (level.type === 'attic' ||
      level.type === 'basement' ||
      level.type === 'crawlspace') &&
    !isLevelConditioned(level) &&
    level.sections.some((section) => section.spaces.length > 0)
  );
}
